module.exports = __webpack_public_path__ + "img/y_2007_hover.6dc38d1a.png";